"use strict";var _interopRequireDefault = require("D:\\work\\svn\\\u5BB6\u7528\u540E\u53F0\\branches\\20240430-1.5.0\\node_modules\\@babel\\runtime/helpers/interopRequireDefault");Object.defineProperty(exports, "__esModule", { value: true });exports.default = void 0;


















var _detailTree = _interopRequireDefault(require("./detailTree"));
var _detailContent = _interopRequireDefault(require("./detailContent")); //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = { name: 'TaskList', components: { DetailTree: _detailTree.default, DetailContent: _detailContent.default }, data: function data() {return { importDialog: false, deviceTypeCode: '' };}, mounted: function mounted() {var self = this;self.deviceTypeCode = self.$route.query.deviceTypeCode;self.handleReturnList();}, methods: {
    // 获取数据
    handleGetContent: function handleGetContent(data) {
      console.log('点击', data);
      var self = this;
      var id = self.$route.query.id;
      self.$refs.detailContent.handleGetDetail(id, data);
    },
    handleReturnList: function handleReturnList() {
      var self = this;
      var id = self.$route.query.id;
      if (!id) {
        self.$router.push('agreelist');
      }
    },
    handleRefreshMenu: function handleRefreshMenu(menuId) {
      this.$refs.detailTree.getMenu(menuId);
    },
    returnFun: function returnFun() {
      // 返回上一级
      this.$router.push('/model/agreelist');
    },
    deployFun: function deployFun() {
      var self = this;
      var id = self.$route.query.id;
      self.getData('/api/deviceModelProtocol/' + id + '/generateJson', {}, function (res) {
        if (res == null) {

          self.$message({
            message: '配置成功!',
            type: 'success' });


        }
      });
    } } };exports.default = _default;